import AuthorityTrustIcon from '@/images/phishing/signs/authority-trust.svg';
import ContextIcon from '@/images/phishing/signs/context.svg';
import CuriosityIcon from '@/images/phishing/signs/curiosity.svg';
import DoTheRightThingIcon from '@/images/phishing/signs/do-the-right-thing.svg';
import FearIcon from '@/images/phishing/signs/fear.svg';
import MediaIcon from '@/images/phishing/signs/media.svg';
import RewardsIcon from '@/images/phishing/signs/rewards.svg';
import TimeSensitivityIcon from '@/images/phishing/signs/time-sensitivity.svg';
import React from 'react';
import styled from 'styled-components';

const TileImage = styled.img`
  width: 38px;
  height: 38px;
  flex-shrink: 0;
`;

const FallbackTile = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: var(--xsmall-border-radius);
  background-color: color-mix(in srgb, var(--green-color) 20%, transparent);
  color: var(--green-color);
  font-weight: 700;
  font-size: var(--medium-font-size);
  text-transform: uppercase;
  flex-shrink: 0;
`;

const phishingSignIcons: Record<string, string> = {
  context: ContextIcon,
  curiosity: CuriosityIcon,
  'do-the-right-thing': DoTheRightThingIcon,
  fear: FearIcon,
  media: MediaIcon,
  rewards: RewardsIcon,
  'time-sensitivity': TimeSensitivityIcon,
  'trust-or-authority': AuthorityTrustIcon,
};

export type PhishingSignIconProps = {
  signKey: string;
};

export const PhishingSignIcon: React.FC<PhishingSignIconProps> = ({
  signKey,
}) => {
  const icon = phishingSignIcons[signKey];

  if (icon) {
    return <TileImage src={icon} alt="" aria-hidden="true" />;
  }

  return <FallbackTile aria-hidden="true">{signKey.charAt(0)}</FallbackTile>;
};
